import ssfRest from '../np-rest/ssfRest';

const restBulkDelete = props => {
    const [SSFRest] = ssfRest(props);
    return [SSFRest]
}

export default restBulkDelete;